// extracted by mini-css-extract-plugin
export default {"PfsTaxRates":"PFSTaxRates_PfsTaxRates__9SVA2"};